/**
 * Bandes défilantes — bande de garanties de l'accueil et bandeau d'avis.
 *
 * Le défilement en boucle réclame assez de copies du groupe pour couvrir la
 * fenêtre PLUS un groupe : l'animation translate de −100 % de la largeur d'UN
 * groupe, et sans cette réserve un vide traverse la bande en fin de cycle.
 *
 * Ces copies étaient écrites en Liquid, rebouclées depuis `section.blocks`.
 * Or un bloc de thème n'expose rien à la section qui l'accueille : la liste
 * est bien là, mais chaque entrée sort en `type: "@theme"` avec un `settings`
 * vide. Les copies partaient donc sans libellé, toutes avec le pictogramme
 * par défaut du schéma. On les fabrique ici, à partir du groupe réellement
 * rendu par l'éditeur — la seule source qui porte le contenu du client.
 *
 * Le nombre de copies se mesure au lieu d'être posé : les quatre copies en dur
 * couvraient 2560px, et le vide revenait au-delà.
 *
 * Sans ce script la bande reste une liste lisible qu'on pousse au doigt :
 * l'animation n'est armée qu'une fois les copies en place.
 */

const CONTENEURS = '[data-defile]';

/**
 * Les attributs d'éditeur désignent un bloc précis. Dupliqués, l'éditeur ne
 * sait plus lequel surligner quand le client clique sur son réglage. Une copie
 * est décorative : elle perd ses attributs, ses identifiants, et sort du champ
 * des lecteurs d'écran — l'original porte déjà le contenu.
 */
function nettoyer(copie) {
  for (const el of [copie, ...copie.querySelectorAll('*')]) {
    for (const { name } of [...el.attributes]) {
      if (name.startsWith('data-shopify')) el.removeAttribute(name);
    }
    el.removeAttribute('id');
  }
  copie.setAttribute('aria-hidden', 'true');
  // `aria-hidden` sort la copie du champ des lecteurs d'écran mais laisse ses
  // liens tabulables : au clavier on traversait des liens invisibles, annoncés
  // par rien. `inert` les retire aussi du parcours de tabulation — c'est ce
  // que Lighthouse signalait sur la barre d'annonce.
  copie.inert = true;
  return copie;
}

function boucler(conteneur) {
  // `data-defile="(max-width: 760px)"` : la bande ne boucle que si la
  // fenêtre répond à la requête — la barre d'annonce défile en mobile et
  // relaie ses messages en fondu en desktop.
  const condition = conteneur.dataset.defile;
  if (condition && !window.matchMedia(condition).matches) return;

  const groupe = conteneur.querySelector('[data-defile-groupe]');
  const piste = groupe?.parentElement;
  if (!piste) return;

  const largeur = groupe.getBoundingClientRect().width;
  // Une bande encore sans mise en page — police en cours de chargement, section
  // masquée — ne se mesure pas : on la laissera au prochain passage.
  if (largeur === 0) return;

  const vise = piste.getBoundingClientRect().width + largeur;
  let total = piste.scrollWidth;

  // Le garde-fou vaut pour un groupe très court : deux garanties sur un écran
  // large boucleraient sinon des dizaines de fois pour rien.
  while (total < vise && piste.children.length < 12) {
    piste.append(nettoyer(groupe.cloneNode(true)));
    total += largeur;
  }

  conteneur.classList.add('est-boucle');
}

function tout() {
  document.querySelectorAll(CONTENEURS).forEach(boucler);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tout);
} else {
  tout();
}

// Les polices arrivent après le premier rendu et changent la largeur du
// groupe : sans ce second passage, une bande mesurée trop tôt reste courte.
document.fonts?.ready.then(tout);

/**
 * L'élargissement de la fenêtre peut découvrir un vide. On complète, on ne
 * retire jamais : enlever des copies ferait sauter l'animation en cours.
 */
let minuteur;
window.addEventListener('resize', () => {
  clearTimeout(minuteur);
  minuteur = setTimeout(tout, 200);
});

// L'éditeur de thème remplace le HTML de la section à chaque réglage modifié :
// les copies partent avec, il faut les refaire.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(CONTENEURS).forEach(boucler);
});
